import PatientTabs from "../tab/PatientTabs";
import PatientDetailsHeader from "../page/PatientDetailsHeader";
import CaseDetails from "../details/sidebar/casedetails/CaseDetails";


import PracticeTable from "../details/practices/PracticeTable";



import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getCaseDetails, getWorkQDrwaer } from "../../../lib/fetchApi";
import { useDispatch, useSelector } from "react-redux";
import { notificationActions } from "../../../store/notifications";

import { caseActions } from "../../../store/case";

import { attorneyActions } from "../../../store/attorneys";

import classes from './PatientDetailsComponent.module.css'
import DocumentsSidebar from "../details/sidebar/documents/DocumentsSidebar";
import RelatedPatients from "../details/sidebar/related/RelatedPatients";
import { workqueueActions } from "../../../store/workqueue";
import AppointmentHistory from "../details/sidebar/history/AppointmentHistory";
import MockPatientDetails from "../../mock/MockPatientDetails";
import { detailsActions } from "../../../store/details";
import DevOnly from "../details/sidebar/dev/DevOnly";
import SocketIntegration from "../socket/SocketIntegration";
import { syncRecentCasesFromCasePayload } from "../../../lib/script";
import { formatPatientName } from "../../../lib/patientName";
import { mergeDrawerCaseWithFullCase, normalizeActiveCaseShape } from "../../../lib/caseUpdateHelpers";

const PatientDetailsInner = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate();
    const { patientId, workqSlug } = useParams();

    const [loading, setLoading] = useState(false)
    const [caseFound, setCaseFound] = useState(null)
    const userToken = useSelector(state => state.user.token)
    // Full case page uses GET /cases/{id}. Pass workQ when URL is /work-queues/:workqSlug/:patientId.
    // Work-queue drawer uses GET /work-queues/{slug}/{id} only (see WorkQDrawer) and does not update recents.
    const workQForApi = workqSlug || null

    useEffect(() => {
        dispatch(workqueueActions.setOpenedDrawer(null))

        const getCase = async () => {
            if (!userToken) {
                return
            }
            setLoading(true)
            try {
                let caseDetail = await getCaseDetails(userToken, patientId, true, workQForApi)

                if (!caseDetail || caseDetail.errorMessage) {
                    if (caseDetail?.errorMessage) {
                        dispatch(notificationActions.setError(caseDetail))
                    }
                    if (workqSlug) {
                        navigate(`/work-queues/${workqSlug}/`, { replace: true })
                    }
                    return
                }

                if (caseDetail.status) {
                    dispatch(notificationActions.setError({ errorMessage: 'Patient does not exists!' }))
                    navigate(`/work-queues/${workqSlug}/`, { replace: true })
                    return
                }

                const isDischarged = !!caseDetail?.case?.is_discharged
                const practices = Array.isArray(caseDetail?.practices) ? caseDetail.practices : []
                const hasPracticeFinalTreatment = practices.some((p) => !!p?.final_treatment)
                const hasGdqExitDate =
                    !!caseDetail?.work_queue_gdq_mrq?.gdq_exit_date ||
                    !!caseDetail?.gdq_mrq?.gdq_exit_date

                if (workqSlug && isDischarged && !hasPracticeFinalTreatment && !hasGdqExitDate) {
                    const drawerSlice = await getWorkQDrwaer(userToken, workqSlug, patientId, true)
                    if (drawerSlice && !drawerSlice.errorMessage) {
                        caseDetail = mergeDrawerCaseWithFullCase(
                            caseDetail,
                            normalizeActiveCaseShape(drawerSlice)
                        )
                    }
                }

                syncRecentCasesFromCasePayload(caseDetail)
                dispatch(caseActions.setActiveCase(caseDetail))
                dispatch(workqueueActions.setLastActiveCase(caseDetail.case.id))
                dispatch(caseActions.pushLastActiveCases({
                    id: caseDetail.case.id,
                    name: formatPatientName(caseDetail.patient),
                    ...(workqSlug ? { workQSlug: workqSlug } : {}),
                    person_number: caseDetail.patient.person_number,
                }))
                setCaseFound(caseDetail)
            } finally {
                setLoading(false)
            }
        }
        dispatch(detailsActions.setIsVerticalListOpened(false))
        dispatch(detailsActions.setDrawerHasOpened(false))
        getCase()

        return function cleanup() {
            dispatch(attorneyActions.removeFirmLocationAttorneySelection())
            dispatch(attorneyActions.removeAssignedAttorney())
        };
    }, [patientId, userToken, dispatch, navigate, workqSlug, workQForApi])


    return <>
        <div className={classes.details_container}>
            {loading && <MockPatientDetails />}     
            {!loading && caseFound && <>
                <div className={classes.main}>
                    {/* ############ header ######## */}
                    <PatientDetailsHeader data={caseFound} hasClear={true} detailsExtraControls={true}/>
                    <div className={classes.flex_group}>
                        {/* ############# PRACTICES ############# */}
                        {caseFound.practices && <PracticeTable data={caseFound.practices.data}/>}
                    </div>
                    <div className={classes.last_child}>
                        {/* ############# TABS ###############  */}
                        <PatientTabs />
                    </div>              
                </div>
                <div className={classes.sidebar}>
                    <div className={classes.item}>
                        <SocketIntegration />
                    </div>
                    <div className={classes.item} style={{position: 'relative', zIndex: 20}}>
                        <CaseDetails />
                    </div>
                    <div className={classes.item} style={{position: 'relative', zIndex: 19}}>
                        <RelatedPatients showSugestedPatients={true}/>
                    </div>
                    <div className={classes.item}>
                        <DocumentsSidebar />
                    </div>
                    <div className={classes.item}>
                        <AppointmentHistory />
                    </div>
                    <div className={classes.item}>
                        <DevOnly />
                    </div>
                    
                </div>
            </>}
        </div>
        
        
    </>
}

export default PatientDetailsInner